import { useEffect, useState } from "react";
import SidebarManager from "../../components/SidebarManager.js";
import Header from "../../components/Header.js";
import NumCard from "../../components/NumCard.js";
import CallToAction from "../../components/CallToAction.js";
import Table from "../../components/Table.js";
import data from "../../components/data.json";
import { useNavigate } from "react-router-dom";
import {
  getCompanyDetails,
  updateCompanyFormStatus,
} from "../../services/companyService.js";
import { getStatusColor } from "../../utils/statusUtils.js";
import { useAuth } from "../../context/AuthContext.js";

const stats = [
  {
    amount: data.filter((row) => row.status === "approved").length,
    text: "Approved",
    colour: "#198754",
  },
  {
    amount: data.filter((row) => row.status === "pending").length,
    text: "Pending Approval",
    colour: "#ffb800",
  },
  {
    amount: data.filter((row) => row.status === "rejected").length,
    text: "Rejected",
    colour: "#c82333",
  },
];

const today = new Date().toLocaleDateString("en-GB", {
  weekday: "long",
  day: "2-digit",
  month: "short",
  year: "numeric",
});

function Submissions() {
  const [loading, setLoading] = useState(true);
  const [companies, setCompanies] = useState([]);
  const [stats, setStats] = useState([]);
  const { user } = useAuth();
  const navigate = useNavigate();

  const fetchCompanies = async () => {
    try {
      setLoading(true);
      //const response = await fetch("/api/company/detail");
      let response = await getCompanyDetails(user);
      response = response.map((x) => ({
        ...x,
        applicationStatusValue: x.applicationStatus.value,
      }));
      //const data = await response.json();
      setCompanies(response.filter((x) => x.hasFormBeenSubmitted === true));
      setLoading(false);
      const statistitcs = [
        {
          amount: response.filter(
            (row) => row.applicationStatus.value.toLowerCase() === "approved"
          ).length,
          text: "Approved",
          colour: "#198754",
        },
        {
          amount: response.filter(
            (row) => row.applicationStatus.value.toLowerCase() === "pending"
          ).length,
          text: "Pending Approval",
          colour: "#ffb800",
        },
        {
          amount: response.filter(
            (row) => row.applicationStatus.value.toLowerCase() === "rejected"
          ).length,
          text: "Rejected",
          colour: "#c82333",
        },
      ];
      setStats(statistitcs);
    } catch (error) {
      setLoading(false);
      console.error("Failed to load company data:", error);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  const columns = [
    { label: "Company Name", key: "name" },
    { label: "Registered Name", key: "registeredName", align: "start" },
    { label: "Website", key: "websiteUrl", align: "start" },
    {
      label: "Industries",
      key: "industries",
      align: "center",
      format: "arrayValue",
    },
    {
      label: "Onboarded on",
      key: "createdAt",
      align: "center",
      format: "date",
    },
    {
      label: "Application Status",
      key: "applicationStatusValue",
      align: "center",
      render: (row) => (
        <span
          className={`text-white px-4 py-1 rounded-lg text-sm hover:opacity-90 ${getStatusColor(
            row.applicationStatus.id
          )}`}
          //onClick={() => redirectToForm(row)}
        >
          {row.applicationStatus.value}
        </span>
      ),
    },
    {
      label: "Action",
      key: "action",
      align: "center",
      render: (row) => (
        <button
          className="bg-[#6f81f5] text-white px-4 py-1 rounded-lg text-sm hover:opacity-90 cursor-pointer"
          onClick={() => goToViewForm(row)}
        >
          View
        </button>
      ),
    },
  ];

  const goToViewForm = async (row) => {
    // UPDATE ONLY IF STATUS IS SUBMITTED
    if (row.applicationStatus.id === 4) {
      const response = await updateCompanyFormStatus(
        row.companyId,
        row.version,
        5
      );
    }
    navigate(
      `/review-form?companyId=${row.companyId}&versionId=${row.version}`
    );
  };

  return (
    // <div className="App flex flex-row">
    //   <SidebarManager />
    // </div>
    <div className="container py-8 px-[5rem] bg-[#fbfbfb]">
      <Header title="Submissions" date={today} buttons={false} />
      <div className="grid grid-cols-3 gap-6 justify-between mb-[2rem]">
        {stats.map((stat, index) => (
          <NumCard amount={stat.amount} text={stat.text} colour={stat.colour} />
        ))}
      </div>

      <div className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Assigned Forms</h2>
        <p className="text-sm mb-4 text-gray-500">Total: 2 Forms</p>
        <Table
          columns={columns}
          rows={companies}
          colour="#c5cdfb"
          loading={loading}
        />
      </div>
    </div>
  );
}
export default Submissions;
